export default "__VITE_ASSET__BzSLjSGp__"